export default {"src":"/login-app/[GIT_HASH]/_next/static/media/pause.e0b63f52.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};